// export const SAS_BACKEND_URL = "http://170.64.138.149:8091/settlement";
// export const SAS_UPLOAD_URL = "http://170.64.138.149:8092/settlement-jobs";

const { REACT_APP_SAS_UPLOAD_URL,REACT_APP_SAS_BACKEND_URL } = process.env
export const SAS_BACKEND_URL = `${REACT_APP_SAS_BACKEND_URL}/settlement`;
export const SAS_UPLOAD_URL = `${REACT_APP_SAS_UPLOAD_URL}/settlement-jobs`;
